import React from "react";
import PropTypes from "prop-types";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

/**
 * HO-TASK-249: los formatos en los que se puede bajar un archivo de datos.
 *
 * Son los mismos que acepta la carga masiva, a propósito: lo que se baja se
 * puede volver a subir sin pasar por Excel. El orden deja primero el .xlsx,
 * que es lo que se bajaba antes de que hubiera algo que elegir.
 */
export const DOWNLOAD_FORMATS = [
  { format: "xlsx", label: "Excel (.xlsx)" },
  { format: "csv", label: "CSV (.csv)" },
  { format: "txt", label: "Texto (.txt)" },
];

/**
 * Botón de descarga con el formato en un desplegable, en vez de tres botones
 * sueltos: ocupa lo mismo que el botón de siempre y no llena la ventana de
 * opciones que casi nadie cambia.
 */
const DownloadFormatDropdown = ({
  label,
  onSelect,
  disabled,
  color,
  size,
  className,
}) => (
  <UncontrolledDropdown className={className}>
    <DropdownToggle color={color} size={size} disabled={disabled} caret>
      <FontAwesomeIcon icon={faDownload} className="mr-2" />
      {label}
    </DropdownToggle>
    <DropdownMenu>
      {DOWNLOAD_FORMATS.map(({ format, label: formatLabel }) => (
        <DropdownItem key={format} onClick={() => onSelect(format)}>
          {formatLabel}
        </DropdownItem>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

DownloadFormatDropdown.propTypes = {
  label: PropTypes.node.isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
};

DownloadFormatDropdown.defaultProps = {
  disabled: false,
  color: "info",
  size: "sm",
  className: "d-inline-block",
};

export default DownloadFormatDropdown;
